import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { DELGuest } from "services/deleteApi";
import { getGuestSingle } from "services/getApi";

const options = {
    weekday: 'long',
    month: 'numeric',
    day: 'numeric',
    year: "numeric"
};

function Table({ Thead, title, data, table = null, setReport , setChange2 }) {
    const redirect = useNavigate();

    return (
        <div className="w-[98%]">
            <div className="overflow-x-auto page-ani">
                <div>
                    <h2 className="text-[18px] mb-2 text-center line-ti">{title}</h2>
                </div>
                <table className="table w-full">
                    <thead className="rounded-[10px]">
                        <tr>
                            {Thead}
                            <th className="rounded-[0] rounded-r">
                                <span>
                                    واحد : تومان
                                </span>
                                <button onClick={() => redirect("print")} className="btn btn-primary mr-2">چاپ</button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data == null ? 'خالی' :
                                data.map(item => (
                                    <Tr setChange={setChange2} setReport={setReport} {...item} />
                                ))

                        }
                    </tbody>
                </table>
            </div>
            {
                table ? null :
                    <Link to="guests" className="w-full flex justify-center items-center">
                        <a class="mt-3 text-center w-auto btn btn-outline h-[2.3rem] px-6" style={{ minHeight: 0 }}>مشاهده بیشتر</a>
                    </Link>
            }
        </div>
    );
}


function Tr({
    fullname,
    number_room,
    city,
    phone,
    login_date,
    logout_date,
    createdAt,
    price_room,
    stay_time,
    discount,
    isSpecial,
    price,
    _id,
    setReport,
    setChange
}) {
    const redirect = useNavigate();
    const [warning, setWarnig] = React.useState(false)

    function handleDEL() {
        setWarnig(true);
        setTimeout(() => {
            setWarnig(false)
        }, 3000);
    }

    function handleApiDEL() {
        DELGuest(_id).then(res => {
            setChange(new Date())
        })
    }

    return (
        <tr className={`mt-2 p-1`}>
            <td className={`bg-[#0006] text-center  ${isSpecial ? "text-error" : ""}`}>{fullname}</td>
            <td className="bg-[#0006] text-center">{number_room}</td>
            <td className="bg-[#0006] text-center">{city}</td>
            <td className="bg-[#0006] text-center">{phone}</td>
            <td className="bg-[#0006] text-center">{login_date}</td>
            <td className="bg-[#0006] text-center">{logout_date}</td>
            <td className="bg-[#0006] text-center">{new Date(createdAt).toLocaleString('fa-IR', options)}</td>
            <td className="bg-[#0006] text-center">{price_room.toLocaleString()}</td>
            <td className="bg-[#0006] text-center">{stay_time.toLocaleString()}</td>
            <td className="bg-[#0006] text-center" dir="ltr">
                <span>{(price * (discount / 100)).toLocaleString()}</span><span> - {discount + "%"}</span>
            </td>
            <td className="bg-[#0006]">{price.toLocaleString()}</td>
            <td className="bg-[#0006]">
                {
                    warning ?
                        <button onClick={handleApiDEL} className="bg-[#0000] hover:bg-[#0002] text-error p-[10px] rounded-[50%]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" />
                                <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" />
                            </svg>
                        </button>
                        :
                        <button onClick={handleDEL} className="bg-[#0000] hover:bg-[#0002] text-error p-[10px] rounded-[50%]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                                <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                            </svg>
                        </button>
                }

                <button onClick={() => redirect("/print/" + _id)} className="bg-[#0000] hover:bg-[#0002] text-info p-[10px] rounded-[50%]">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                    </svg>
                </button>
            </td>
        </tr>
    )
}

export default Table;